export default __webpack_public_path__ + "50ba65ce7ac51e7402d1f50069279986.svg";